import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

interface IProps {
  children?: ReactNode,
  id?: 'string'
  selectedTab?: 'string'
}

const variants = {
  open: {
    height: 'auto',
    transition: {
      ease: 'easeOut',
      duration: .2,
    },
  },
  closed: {
    height: 0,
    transition: {
      ease: 'easeIn',
      duration: .2,
      delay: .1,

    },
  },
}
const Expanded = ({ children, selectedTab, id }: IProps) => {

  return (
    <Answer
      variants={variants}
      initial='closed'
      animate={selectedTab === id ? 'open' : 'closed'}
    >
      {children}
    </Answer>
  )
}

const Answer = styled(motion.div)`
  overflow: hidden;
`

export default Expanded
